import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { useEffect, useState, useRef } from "react";
import { PortfolioService } from "../../../services/portfolio.service";
import { useParams } from "react-router";
import { useSite } from "../../../context/SiteContext";
import '../../../assets/css/style.css';

interface DetailPage {
  id: number;
  slug: null | string;
  link: string;
  images: string[][];
}

const ProjectDetail = () => {
  const { data } = useSite();
  const { id } = useParams();
  const [project, setProject] = useState<DetailPage | null>(null);
  const swiperRefs = useRef<any[]>([]);
  const [activeIndex, setActiveIndex] = useState(0); // Initial active index set to 0

  useEffect(() => {
    async function fetchDetail() {
      const response = await PortfolioService.getAllPortfolioDetail(id);
      if (response.status === 200) {
        setProject(response.data.data);
      }
    }
    fetchDetail();
  }, [id]);

  return (
    <div className="project-section">
      <div className="project-title">{data?.portfolio}</div>
      <div className="project-slider-container">
        {project && project.images && project.images.length > 0 ? (
          project.images.map((imageGroup, groupIndex) => {
            const shouldLoop = imageGroup.length > 3;
            const slidesPerView = Math.min(imageGroup.length, 3);

            return (
              <div key={groupIndex} className="swiper-wrapper-container">
                <Swiper
                  className="customSwiperWithBorder"
                  navigation={{
                    nextEl: `.custom-next-${groupIndex}`,
                    prevEl: `.custom-prev-${groupIndex}`,
                  }}
                  modules={[Navigation]}
                  spaceBetween={20}
                  slidesPerView={slidesPerView}
                  centeredSlides={slidesPerView > 1}
                  loop={true}
                  initialSlide={0}
                  onSwiper={(swiper: any) => {
                    swiperRefs.current[groupIndex] = swiper;
                  }}
                  onSlideChange={(swiper: any) => {
                    setActiveIndex(swiper.realIndex);
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                      centeredSlides: true,
                    },
                    500: {
                      slidesPerView: 3,
                      centeredSlides: true,
                    },
                    768: {
                      slidesPerView: 3,
                      centeredSlides: true,
                    }
                  }}
                >
                  {imageGroup.map((img, index) => (
                    <SwiperSlide key={index}>
                      <div className={`custom-project-card-with-border ${index === activeIndex ? 'active-slide' : ''}`}>
                        <div className="custom-project-image-container">
                          <img src={img} alt={`Project ${index + 1}`} />
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

                {imageGroup.length > 3 && (
                  <>
                    <div className={`custom-prev custom-prev-${groupIndex}`}>‹</div>
                    <div className={`custom-next custom-next-${groupIndex}`}>›</div>
                  </>
                )}

                {project?.link && (
                  <button
                    onClick={() => window.open(project.link, "_blank")}
                    className="custom-project-btn"
                  >
                    {project?.slug || "Mobil tətbiqi yüklə"}
                  </button>
                )}
              </div>
            );
          })
        ) : (
          <div className="project-card">
            <div className="project-image-container"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectDetail;
